export default (value) => {
  if (isNaN(value)) {
    return ''
  }
  return value
}



// WEBPACK FOOTER //
// ./src/filters/donotshownanvalue.js